<template>
  <v-navigation-drawer
    temporary
    :value="drawer"
    stateless
    app
    id="mainnav"
    class="secondary"
  >
    <v-list class="white--text pb-5">
      <v-list-item class="">
        <v-list-item-avatar>
          <v-img src="/img/logod.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-title class="text-h5 font-weight-bold white--text"
          >DIMITRA</v-list-item-title
        >
      </v-list-item>
    </v-list>
    <!---->
    <!-- style="position: absolute; top: 4px; right: 0px; font-size: 2.12rem" -->
    <v-icon color="secondary" class="close-btn" @click="setCloseDrawer()"
      >mdi-close</v-icon
    >
    <!---->
    <v-divider color="gray"></v-divider>
    <v-list nav dense v-for="(item, idx) in permissions" :key="idx">
      <v-list-item
        :exact="item.exact"
        active-class="primary"
        class=""
        v-if="!item.submenus"
        :to="item.url"
        link
      >
        <v-list-item-icon>
          <v-icon class="white--text font-weight-bold">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text font-weight-bold">{{
            item.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group
        v-else
        :value="false"
        no-action
        active-class="primary"
        class="white--text"
      >
        <template #prependIcon>
          <v-icon class="white--text">mdi-cow</v-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              item.name
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(subitem, i) in item.submenus"
          :key="i"
          :to="subitem.url"
          link
        >
          <v-list-item-title
            v-text="subitem.name"
            class="white--text"
          ></v-list-item-title>

          <v-list-item-icon>
            <v-icon class="white--text">mdi-{{ subitem.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <div class="text-no-wrap text-caption text-center white--text mb-5">
        Version <br v-if="drawer" />
        1.0.0
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import isMobileMixin from "@/mixins/isMobileMixin";
export default {
  name: "tabletSidebar",
  created() {},
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        return this.$store.commit("SET_DRAWER", !val);
      },
    },
    permissions() {
      return this.$store.getters.getUserPermissions(this.menuItems);
    },
  },
  methods: {
    setCloseDrawer() {
      this.$store.commit("SET_DRAWER", false);
    },
  },
  data() {
    return {
      menuItems: [
        {
          id: 10,
          icon: "mdi-view-grid-outline",
          name: "Dashboard",
          url: { name: "AdminDashboard" },
          exact: true,
        },
        {
          id: 2,
          icon: "mdi-account-multiple-outline",
          name: "Users",
          url: { name: "Users" },
          exact: false,
        },
        {
          id: 5,
          icon: "mdi-tab-unselected",
          name: "Farms",
          url: { name: "My farm" },
          exact: false,
        },
        {
          id: 1,
          icon: "mdi-cow",
          name: "Animals",
          url: { name: "Animals" },
          exact: false,
        },
        {
          id: 11,
          icon: "mdi-dots-horizontal-circle-outline",
          name: "Action List",
          url: { name: "ActionList" },
          exact: false,
        },
        {
          id: 12,
          icon: "mdi-pill",
          name: "Drug Inventory",
          url: { name: "DrugList" },
          exact: false,
        },
        {
          id: 13,
          icon: "mdi-file-chart",
          name: "Analytics and Reporting",
          url: { name: "Analytics" },
          exact: false,
        },
        {
          id: 16,
          icon: "mdi-chart-areaspline",
          name: "Inseminators Statistics",
          url: { name: "InseminatorList" },
          exact: false,
        },
        {
          id: 14,
          icon: "mdi-sitemap",
          name: "Organization NTR",
          url: { name: "ProductList" },
          exact: false,
        },
        // { id: 18 , icon: "mdi-bank-outline", name: "Semen Gene Bank", url: { name: 'GeneList'} , exact: false},
        {
          id: 17,
          icon: "mdi-file-chart",
          name: "GenoType Performance",
          url: { name: "GenoList" },
          exact: false,
        },
        {
          id: 15,
          icon: "mdi-chart-areaspline",
          name: "Semen Automation",
          url: { name: "SemenAuto" },
          exact: false,
        },
        // { icon: "account", name: "User Profile", url: { name: 'profile'}, exact: false },
      ],
    };
  },
  mixins: [isMobileMixin],
};
</script>

<style scoped>
.close-btn {
  position: absolute;
  top: 18px;
  right: 4px;
  font-size: 2rem;
  background: #02b671;
  border-radius: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>